import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import HMap from './hmap';

const txtArr = ['少出门！戴口罩！', '不聚会！不添乱！', '不恐慌！不传谣！'];

let txtIndex = 0;

class ShareImg extends React.PureComponent {
    static propTypes = {
        hbType: PropTypes.string,
        areaName: PropTypes.string,
        data: PropTypes.object,
        time: PropTypes.string,
        shareNum: PropTypes.number,
        mapData: PropTypes.array,
        nanhai: PropTypes.string,
    };

    getAreaList = areaName => {
        if (!areaName) return {};

        const { mapData } = this.props;

        let areaList = {};

        mapData.every(item => {
            if (areaName === item.name1) {
                areaList = item;

                return false;
            }

            return true;
        });

        return areaList;
    };

    render() {
        const { hbType, areaName, data, time, shareNum, mapData, nanhai } = this.props;

        const areaList = this.getAreaList(areaName);

        txtIndex = shareNum % 3;

        return (
            <div
                id={hbType === 'all' ? 'all' : 'area'}
                className={styles.haibao}
                style={{ left: hbType === 'all' ? '-760px' : '-1520px' }}>
                {hbType === 'all' ? (
                    <img
                        id="h_bg"
                        crossOrigin="Anonymous"
                        src="https://x0.ifengimg.com/ucms/2022_05/50C44D33D2F7584B7E2F53094886F36BF32D846B_size563_w2800_h4980.jpg"
                    />
                ) : (
                    <Fragment>
                        <img
                            id="h_bg"
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2022_05/8AD3B93E8F60C9E4AD57D61AAFF3A13681E0C6AA_size528_w2800_h4980.jpg"
                        />
                        <div className={styles.a_title}>
                            #<span>{areaName}</span>疫情速报#
                        </div>
                    </Fragment>
                )}
                <div id="h_box" className={styles.h_box}>
                    {hbType === 'all' ? (
                        <div className={styles.h_ditu}>
                            <div className={styles.h_ditubox}>
                                {data && (
                                    <Fragment>
                                        <span>{time}</span>
                                        <div className={styles.h_sum}>
                                            <div className={styles.h_num1}>
                                                <span>{data.quezhen - data.zhiyu - data.siwang}</span>
                                                <img
                                                    crossOrigin="Anonymous"
                                                    src="https://x0.ifengimg.com/ucms/2020_10/93C588254865877B38B1008814ABE56F1A5FE236_w248_h72.png"
                                                />
                                            </div>
                                            <div className={styles.h_num2}>
                                                <span>{data.quezhen}</span>
                                                <img
                                                    crossOrigin="Anonymous"
                                                    src="https://x0.ifengimg.com/ucms/2020_10/807B910639A58078CEFBDBE3D13707B26B49B5D0_w248_h72.png"
                                                />
                                            </div>
                                            <div className={styles.h_num3}>
                                                <span>{data.zhiyu}</span>
                                                <img
                                                    crossOrigin="Anonymous"
                                                    src="https://x0.ifengimg.com/ucms/2020_10/C402C2E4CEED359EFF950AEF9BDE08206A1E2670_w248_h72.png"
                                                />
                                            </div>
                                            <div className={styles.h_num4}>
                                                <span>{data.siwang}</span>
                                                <img
                                                    crossOrigin="Anonymous"
                                                    src="https://x0.ifengimg.com/ucms/2020_10/6DC21E60B383A5E8CDDCC1F5E781E8D840CA3E61_w248_h72.png"
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                                <HMap data={[...mapData]} nanhai={nanhai} />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.a_box}>
                            <p>
                                我正在关注<span>{areaName}</span>疫情
                            </p>
                            <p>{time}</p>
                            <div className={styles.a_num}>
                                <div>
                                    <span>{areaList.quezhen_add || 0}</span>
                                    <span>昨日新增</span>
                                </div>
                                <div>
                                    <span>{areaList.quezhen || 0}</span>
                                    <span>累计确诊</span>
                                </div>
                                <div>
                                    <span>{areaList.zhiyu || 0}</span>
                                    <span>累计治愈</span>
                                </div>
                                <div>
                                    <span>{areaList.siwang || 0}</span>
                                    <span>累计死亡</span>
                                </div>
                            </div>
                            <div className={styles.a_data}>
                                <div className={styles.a_thead}>
                                    <span>地区</span>
                                    <span>昨日新增</span>
                                    <span>确诊</span>
                                    <span>治愈</span>
                                    <span>死亡</span>
                                </div>
                                {areaList.child &&
                                    areaList.child.map(item => (
                                        <div key={item.name2} className={styles.a_expand}>
                                            <span>{item.name2}</span>
                                            <span>{item.quezhen_add || 0}</span>
                                            <span>{item.quezhen || 0}</span>
                                            <span>{item.zhiyu || 0}</span>
                                            <span>{item.siwang || 0}</span>
                                        </div>
                                    ))}
                                <div className={styles.a_mask} />
                            </div>
                        </div>
                    )}
                    <div className={styles.h_qr}>
                        <img
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2020_06/703D7ED0C944728E81369E49E3A7A5E55F157253_w2286_h879.png"
                        />
                        <span className={styles.h_kouhao}>{txtArr[txtIndex]}</span>
                        <span># 理性抗疫 我在行动 #</span>
                        <span className={styles.h_num}>
                            我是第<span>{shareNum}</span>
                            个抗疫接力者
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ShareImg);
